import React from 'react'
import { Link, useLocation, useNavigate } from "react-router-dom"
import { generalAssets } from '../../../assets/media'


const DesktopNav = () => {
    const navigate = useNavigate()
    const { logo } = generalAssets.brandLogo

    const { pathname } = useLocation()
    const navList = [
        {
            name: "About Us",
            url: "/about"
        },
        {
            name: "Pricing",
            url: "/plans"
        },
        {
            name: "Test Library",
            url: "/test-library"
        },
        {
            name: "Contact",
            url: "/contact"
        },
    ]

    return (
        <div className="navWrapper lg:flex lg:justify-between lg:items-center hidden w-[95vw] sm:w-[40rem] lg:w-[90vw] mx-auto py-2">

            {/* logo */}
            <div className="brandLogo lg:block flex justify-between items-center w-[16rem]">
                <Link to="/" >
                    <img src={['/', '/test-library'].includes(pathname) ? logo : logo} className="w-full h-full" alt="logo" />
                </Link>
            </div>

            {/* navigation */}
            <nav>
                <ul className='flex justify-center 2xl:items-center'>
                    {
                        navList.map((navItem, index) => (
                            <li onClick={() => navigate(navItem.url)} key={`liNavItem${navItem.name}${index}`} 
                            className={`${pathname === navItem.url && 'font-semibold border-b-2 border-black'}
                             mx-2 sm:mx-3 w-full cursor-pointer active:font-semibold text-center hover:font-semibold 
                             py-1 sm:w-[6rem] lg:w-[6rem]  text-[12px] lg:text-[15px] lg:py-2 xl:w-[6rem] 2xl:w-[8rem] 
                             2xl:text-[20px] 2xl:leading-[34px] font-[600] 2xl:font-[600] 2xl:py-1`}>{navItem.name}</li>
                        ))
                    }
                    <li className=' lg:ml-2'>
                        <Link to={"/free"}>
                            <button  className={`bg-[#333333] border border-[#333333] text-white rounded-3xl px-2 py-1 hover:font-semibold inline-flex items-center justify-center  text-center  2xl:h-[60px] 2xl:rounded-[30px] 2xl:text-[24px] 2xl:leading-[36px] 2xl:!font-600 hover:!bg-[#333333] hover:text-[#333333] hover:!bg-transparent hover:!border hover:!border-[#333333] text-[10px] mx-4 leading:leading-[34px]  !w-[4.5rem] sm:!w-[6rem] md:!w-[6rem] h-[28px] lg:text-[15px] xl:!text-[15px] lg:!w-[11rem] lg:!h-[2.4rem] 2xl:!w-[11rem] transition-all delay-75`}>
                                <span className="">START FREE TRIAL</span>
                            </button>
                        </Link>
                    </li>
                    <li className='lg:ml-2'>
                        <a href="https://platform.thetalent.games" target='_blank'>
                            <button style={{fontWeight :600}}  className={`text-[#333333] inline-flex items-center hover:decoration-solid hover:underline justify-center text-center 2xl:h-[60px] 2xl:text-[24px] lg:!font-800 2xl:!font-800 text-[10px] mx-4 h-[28px] lg:text-[15px] xl:!text-[15px]  lg:!h-[2.4rem]  transition-all delay-75`}>
                                <span className="">LOGIN</span>
                            </button>
                        </a>
                    </li>
                </ul>
            </nav>
        </div>
    )
}

export default DesktopNav